import {
    confirmPermanentEmptyFolderUnreadItemsText,
    confirmPermanentEmptyFolderFlaggedItemsText,
    confirmPermanentEmptyFolderAllToMeItemsText,
    confirmPermanentEmptyFolderAllItemsText,
    confirmPermanentEmptyFolderUnreadConversationsText,
    confirmPermanentEmptyFolderFlaggedConversationsText,
    confirmPermanentEmptyFolderAllToMeConversationsText,
    confirmPermanentEmptyFolderAllConversationsText,
    confirmEmptyFolderAndUnreadItemsForFolderUnderDeletedItemsText,
    confirmEmptyFolderAndAllToMeItemsForFolderUnderDeletedItemsText,
    confirmEmptyFolderAndAllItemsForFolderUnderDeletedItemsText,
    confirmEmptyFolderAndFlaggedItemsForFolderUnderDeletedItemsText,
    confirmEmptyFolderAndUnreadConversationsForFolderUnderDeletedItemsText,
    confirmEmptyFolderAndAllToMeConversationsForFolderUnderDeletedItemsText,
    confirmEmptyFolderAndAllConversationsForFolderUnderDeletedItemsText,
    confirmEmptyFolderAndFlaggedConversationsForFolderUnderDeletedItemsText,
    confirmPermanentEmptyFolderAllSelectedItemsText,
    confirmPermanentEmptyFolderAllSelectedConversationsText,
    confirmEmptyFolderAndAllSelectedConversationsForFolderUnderDeletedItemsText,
    confirmEmptyFolderAndAllSelectedItemsForFolderUnderDeletedItemsText,
} from '../emptyFolder.locstring.json';
import ViewFilter from 'owa-service/lib/contract/ViewFilter';

/**
 * Get the type of items to permanently delete based on view filter and message view
 * @param viewFilter the view filter
 * @param isMessageView the message view - is items or conversations view
 * @param isVirtualExclusion is virtually exclusive or not
 * @param isSubFolder are we deleting a subfolder or not
 * @returns the text which indicates type of items to delete based on the view filter
 * and the message view.
 */
export default function getItemsTypeTextForPermanentDelete(
    viewFilter: ViewFilter,
    isMessageView: boolean,
    isVirtualExclusion: boolean,
    isSubFolder: boolean
): string {
    switch (viewFilter) {
        case 'Unread':
            return isMessageView
                ? isSubFolder
                    ? confirmEmptyFolderAndUnreadItemsForFolderUnderDeletedItemsText
                    : confirmPermanentEmptyFolderUnreadItemsText
                : isSubFolder
                ? confirmEmptyFolderAndUnreadConversationsForFolderUnderDeletedItemsText
                : confirmPermanentEmptyFolderUnreadConversationsText;

        case 'Flagged':
            return isMessageView
                ? isSubFolder
                    ? confirmEmptyFolderAndFlaggedItemsForFolderUnderDeletedItemsText
                    : confirmPermanentEmptyFolderFlaggedItemsText
                : isSubFolder
                ? confirmEmptyFolderAndFlaggedConversationsForFolderUnderDeletedItemsText
                : confirmPermanentEmptyFolderFlaggedConversationsText;

        case 'ToOrCcMe':
            return isMessageView
                ? isSubFolder
                    ? confirmEmptyFolderAndAllToMeItemsForFolderUnderDeletedItemsText
                    : confirmPermanentEmptyFolderAllToMeItemsText
                : isSubFolder
                ? confirmEmptyFolderAndAllToMeConversationsForFolderUnderDeletedItemsText
                : confirmPermanentEmptyFolderAllToMeConversationsText;

        case 'All':
        default:
            return getTextForVirtualExclusion(isMessageView, isVirtualExclusion, isSubFolder);
    }
}

// This function is responsible for determining the text for confirm dialog whether it is a message view
// or if it is virtual exclusion mode with a few items deselected.
function getTextForVirtualExclusion(
    isMessageView: boolean,
    isVirtualExclusion: boolean,
    isSubFolder: boolean
): string {
    if (isMessageView) {
        // items view
        if (isVirtualExclusion) {
            return isSubFolder
                ? confirmEmptyFolderAndAllSelectedItemsForFolderUnderDeletedItemsText
                : confirmPermanentEmptyFolderAllSelectedItemsText;
        } else {
            return isSubFolder
                ? confirmEmptyFolderAndAllItemsForFolderUnderDeletedItemsText
                : confirmPermanentEmptyFolderAllItemsText;
        }
    } else {
        // conversations view
        if (isVirtualExclusion) {
            return isSubFolder
                ? confirmEmptyFolderAndAllSelectedConversationsForFolderUnderDeletedItemsText
                : confirmPermanentEmptyFolderAllSelectedConversationsText;
        } else {
            return isSubFolder
                ? confirmEmptyFolderAndAllConversationsForFolderUnderDeletedItemsText
                : confirmPermanentEmptyFolderAllConversationsText;
        }
    }
}
